import styled from 'styled-components';

import { body } from '@constants/fonts';

export const RoutineListDiv = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  div:first-child {
    border-top: 0px;
  }
  border-radius: 8px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows[1]};

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

export const ListHeader = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-family: ${body};
  font-size: 15px;
  vertical-align: middle;
  line-height: 50px;
  margin: 0px;
  letter-spacing: 0.32px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  height: 50px;
  text-transform: uppercase;
  padding: 4px 24px 0 24px;
  font-weight: 500;

  ${(props) => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;
